import { render, staticRenderFns } from "./AwardsCard.vue?vue&type=template&id=0fa0d1d0&"
import script from "./AwardsCard.vue?vue&type=script&lang=js&"
export * from "./AwardsCard.vue?vue&type=script&lang=js&"
import style0 from "./AwardsCard.vue?vue&type=style&index=0&id=0fa0d1d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports